/*
 * File: useOrders.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Custom hook for state managment for fetching orders from the api
 * Used for dashboard orders summary card
 */
import { useState, useEffect } from "react";
import Api from "services/orders/Api";

const useOrders = () => {
  const [loading, setLoading] = useState(true);
  const [ordersCount, setOrdersCount] = useState(0);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    //Fetch count of all open orders (API uses statuses=0 to indicate searching all open statuses)
    const count = await Api.fetchCount("statuses=0");
    setLoading(false);
    setOrdersCount(count);
  };

  return { loading: loading, ordersCount: ordersCount };
};

export default useOrders;
